import { createContext } from 'react';

export const XYChartIdContext = createContext<string | undefined>(undefined);
